import { useEffect, useRef } from 'react'
import type L from 'leaflet'
import type { MapMode } from '../../../../types'

interface UseMapRotationProps {
  mapRef: React.MutableRefObject<L.Map | null>
  isInitializedRef: React.MutableRefObject<boolean>
  mapMode: MapMode
  heading: number | null
  compassLocked: boolean
  manualRotation: number | null
}

export const useMapRotation = ({
  mapRef,
  isInitializedRef,
  mapMode,
  heading,
  compassLocked,
  manualRotation,
}: UseMapRotationProps) => {
  const mapRotRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!mapRotRef.current || !mapRef.current || !isInitializedRef.current) return

    if (compassLocked) {
      if (manualRotation != null) {
        mapRotRef.current.style.transform = `rotate(${-manualRotation}deg) scale(1)`
      } else {
        mapRotRef.current.style.transform = 'rotate(0deg) scale(1)'
      }
    } else if (mapMode === 'north') {
      mapRotRef.current.style.transform = 'rotate(0deg) scale(1)'
    } else if (heading != null) {
      mapRotRef.current.style.transform = `rotate(${-heading}deg) scale(1.22)`
    }
  }, [mapMode, heading, compassLocked, manualRotation, mapRef, isInitializedRef])

  return { mapRotRef }
}
